<div>
  <strong>Renew Subscriptions</strong> /
</div>
<hr class="hrDiv">
<div class="container" *ngIf="!loaded"><mat-spinner></mat-spinner></div>
<div class="child-container">
<table *ngIf="loaded" class="table-div">
  <tbody>
  <tr>
    <td>
      <div>
        <h1>Renew Your Subscription</h1><br>
      </div> 
      <div *ngIf="subscriptions.length === 0">Please return back in 24 hrs to renew the agreement</div>
    
      <div *ngIf="subscriptions.length > 0">        
        <div><strong>How to Renew Your Subscription:</strong></div>
        <ol>
          <li>Click the Renew link to be redirected to the Shopping Cart.</li>
          <li>In the Shopping Cart, adjust the number of licensed users (1–10) by updating the quantity.</li>
          <li>You can renew at any time before your subscription expires. </li>
        </ol>   
        <div><strong>Important Notes:</strong></div>
        <ul style="list-style-type:disc;">
          <li>Renewals are accepted by credit card only.</li>
          <li>All transactions are subject to the User License Agreement.</li>
        </ul>
        <div><strong>Need Help?</strong></div>
        <div>
          Contact the Unified Service Center at 800-621-8335, Monday–Friday, 8:30 AM–4:45 PM CT.
        </div>           
      </div>
      <br>     
      <div *ngIf="!isSmallView && subscriptions.length > 0">
        <table class="full">
          <tbody>
          <tr>
          <td class="col1">
          <mat-spinner *ngIf="!loaded"></mat-spinner>
          <mat-card class="mat-card sm" *ngFor="let sub of subscriptions">
            <mat-card-content>
            <div><b>{{sub.productName}}</b></div>
            <div>{{sub.productType}}</div>
            <div><img src="{{getProductImage(sub.productNumber)}}"/></div>
            <div>{{sub.term}}</div>
            <div>Users: {{sub.userCount}}</div>
            <div>Start Date:{{sub.startDate}}</div>
            <div>Exp Date: {{sub.expireDate}}</div>
            <div>Amount: {{sub.totalAmount}}</div>
            <br>                 
            <div class="btn-right"><button mat-fab extended class="btn-cls md" (click)="renew(sub.agreementId)">Renew</button></div>
            </mat-card-content>      
          </mat-card>  
        </td>
        <td class="col2"></td>
        <td class="col3">
          <mat-card class="mat-card sm" *ngIf="subscriptions.length>0"> 
            <mat-card-content>
              <div><b>Manage RBRVS DataManager Users</b></div><br>
              <div>As a purchaser you can designate user(s) as secondary administrators to manage license seats, and or designate user(s) for product licenses purchased.</div><br>
              <div><button mat-fab extended class="btn-cls" [routerLink]="['/manage-admins']">Manage RBRVS DataManager Users</button></div>
            </mat-card-content>        
          </mat-card>
        </td>
        </tr>
        </tbody>
        </table>
      </div>
      <div *ngIf="isSmallView && subscriptions.length>0"> 
        <mat-card class="mat-card lg-flx" *ngFor="let sub of subscriptions">
          <mat-card-content>
          <div><b>{{sub.productName}}</b></div>
          <div>{{sub.productType}}</div>
          <div><img src="{{getProductImage(sub.productNumber)}}"/></div>
          <div>{{sub.term}}</div>
          <div>Users: {{sub.userCount}}</div>
          <div>Start Date:{{sub.startDate}}</div>
          <div>Expiration Date: {{sub.expireDate}}</div>
          <div>Amount: {{sub.totalAmount}}</div>
          <br>                 
          <div ><button mat-fab extended class="btn-cls md" (click)="renew(sub.agreementId)">Renew</button></div>
          </mat-card-content>      
        </mat-card> <br>
        <mat-card class="mat-card lg-flx"> 
            <mat-card-content>
              <div><b>Manage RBRVS DataManager Users</b></div><br>
              <div>As a purchaser you can designate user(s) as secondary administrators to manage license seats, and or designate user(s) for product licenses purchased.</div><br>
              <div><button mat-fab extended class="btn-cls" [routerLink]="['/manage-admins']">Manage RBRVS DataManager Users</button></div>
            </mat-card-content>        
        </mat-card>
      </div>
  </td>
</tr>
</tbody>
</table>
</div>
